export default "__VITE_ASSET__bd7db83b__"